import { Component, output, OutputEmitterRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from "../../button/button.component";

@Component({
  selector: 'app-modal-header',
  imports: [ButtonComponent],
  templateUrl: './modal-header.component.html',
  styleUrl: './modal-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ModalHeaderComponent {
  public OnHeaderCloseButtonClicked: OutputEmitterRef<void> = output<void>();

  public OnHeaderCloseButtonClick(): void{
    this.OnHeaderCloseButtonClicked.emit();
  }
}